import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { DataStoreService } from './data_store/data-store.service';

@Injectable({
  providedIn: 'root',
})
export class RoleGuardService {
  private readonly dataStore = inject(DataStoreService);
  private readonly router = inject(Router);

  /**
   * Assesses local token payload properties against permitted access matrices
   * Supports both single string roles and multiple role configuration arrays!
   */
  checkRoleAccess(allowedRoles: string[]): boolean {
    const rawRoles = this.dataStore.getRole();

    if (!rawRoles) {
      this.router.navigate(['/login']);
      return false;
    }

    // 1. Normalize the active user's role configuration into a clean array
    const userRolesArray = Array.isArray(rawRoles)
      ? rawRoles.map((r: string) => r.toUpperCase())
      : [rawRoles.toUpperCase()];

    const allowedUpper = allowedRoles.map(r => r.toUpperCase());

    // 2. Core Security Check: Does the user possess AT LEAST ONE permitted role?
    const hasPermission = userRolesArray.some(role => allowedUpper.includes(role));

    if (!hasPermission) {
      console.warn(`Security Intercept: Unauthorized URL breach attempt by roles:`, userRolesArray);
      this.router.navigate(['/nav/home']); // Safe fallback rebound redirection
      return false;
    }

    return true; // Access granted cleanly
  }
}
